import script from "./BindUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./BindUser.vue?vue&type=script&lang=ts&setup=true"

import "./BindUser.vue?vue&type=style&index=0&id=cd97295e&lang=scss"

const __exports__ = script;

export default __exports__